var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { mergeProps } from '@react-aria/utils';
import { useFocusRing } from '@react-aria/focus';
import { enhancerStyle } from './styles';
function Enhancer(_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, restProps = __rest(_a, ["children", "size"]);
    var _c = useFocusRing(), focusProps = _c.focusProps, isFocusVisible = _c.isFocusVisible;
    return (_jsx("button", __assign({ type: "button" }, mergeProps(focusProps, restProps), { css: enhancerStyle({ isFocusVisible: isFocusVisible }) }, { children: children && children.props.size
            ? children
            : cloneElement(children, {
                // Handle large buttons having medium sized icons by default
                size: size === 'large' ? 'medium' : size,
            }) })));
}
export default Enhancer;
